module.exports = __webpack_public_path__ + "static/w-iridium-advertising-d7b216707db9b34168be2330054880ea.webp";